import { render } from "./Beranda.vue?vue&type=template&id=789ca6ba"
import script from "./Beranda.vue?vue&type=script&lang=js"
export * from "./Beranda.vue?vue&type=script&lang=js"

import "./Beranda.vue?vue&type=style&index=0&id=789ca6ba&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__